/* Copyright (c) 2020-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Container, Row } from "react-awesome-styled-grid";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Box, FlexContainer, theme } from "@nordcloud/gnui";
import { Logo, User } from "./components";
import { CustomerSwitcher } from "./components/SwitchCustomer/CustomerSwitcher";

const StyledLink = styled(Link)`
  display: flex;
  height: 100%;
  align-items: center;
  padding-left: ${theme.spacing.spacing02};
`;

export function Header() {
  return (
    <Box py={theme.spacing.spacing02} mb={0} css={{ borderRadius: 0 }}>
      <Container fluid>
        <Row justify="space-between">
          <span>
            <StyledLink to="/">
              <Logo />
            </StyledLink>
          </span>
          <FlexContainer>
            <CustomerSwitcher />
            <User />
          </FlexContainer>
        </Row>
      </Container>
    </Box>
  );
}
